import { juxt } from "@thi.ng/compose";
import { step } from "../step";
import { map } from "./map";
export function multiplex(...args) {
    return map(juxt.apply(null, args.map(step)));
}
